/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import background from "../images/background.jpg";
import { Container, Mask, StyledHero } from "./Styled";
import Menu from "./Menu";

const Hero = ({ children, container = true }) => {
  return (
    <StyledHero className="hero flex flex-col justify-center">
      <Menu />
      {container && (
        <Container className="content">
          <div className="flex justify-center p-10 md:p-20 flex-wrap">
            {children}
          </div>
        </Container>
      )}
      {!container && (
        <div className="flex justify-center p-5 md:p-20 flex-wrap no_container relative z-30">
          {children}
        </div>
      )}
      <div className="absolute left-0 bottom-0 w-full h-full z-10 flex">
        <img
          src={background}
          className="w-full block object-cover"
          alt="punk"
        />
      </div>
      <Mask />
    </StyledHero>
  );
};
export default Hero;
